import React, { FC } from 'react';
import TrackVisibility from 'react-on-screen';

import { ImpressionWrapper } from './ImpressionWrapper';

interface WithImpressionProps {
  children: JSX.Element | JSX.Element[];
  onImpression: VoidFunction;
  once?: boolean;
  partialVisibility?: boolean;
}

export const WithImpression: FC<WithImpressionProps> = ({
  children,
  onImpression,
  partialVisibility = false,
  once = false,
}: WithImpressionProps) => (
  <TrackVisibility partialVisibility={partialVisibility} once={once}>
    {({ isVisible }) => (
      <ImpressionWrapper isVisible={isVisible} onImpression={onImpression}>
        {children}
      </ImpressionWrapper>
    )}
  </TrackVisibility>
);
